import * as React from "react";
import { MapContainer, Marker, TileLayer, useMapEvents } from "react-leaflet";
import ReactLeafletKml from "react-leaflet-kml";
import { ZONE_COUVERTURE } from "../../Utils/constant";
import { find } from "../../services/service";
function Kml({ userLocation, setUserLocation, zoneCouverte, setLatitude, setLongitude }) {
    const [kml, setKml] = React.useState(null);

    const LocationFinderDummy = () => {
        useMapEvents({
            click(e) {
                setUserLocation([e?.latlng?.lat, e?.latlng?.lng])
                setLatitude(e?.latlng?.lat)
                setLongitude(e?.latlng?.lng)
            },
        });
        return (
            userLocation ? <Marker position={userLocation}>
            </Marker > : null
        );
    };

    React.useEffect(() => {
        if (zoneCouverte) {
            find(`${ZONE_COUVERTURE}/${zoneCouverte.id}`)
                .then((kmlText) => {
                    const parser = new DOMParser();
                    const kml = parser.parseFromString(kmlText.data, "text/xml");
                    setKml(kml);
                });
        }
    }, [zoneCouverte]);

    const handleMarkerClick = (e) => {
        setUserLocation([e?.latlng?.lat, e?.latlng?.lng])
        setLatitude(e?.latlng?.lat)
        setLongitude(e?.latlng?.lng)
    }

    return (
        <div>
            <MapContainer
                style={{ height: "500px", width: "100%", zIndex: 0 }}
                zoom={12}
                bounds={userLocation ? userLocation : [[5.316667, -4.033333], [5.3677654, -3.9596936]]}
            >
                <LocationFinderDummy />
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {
                    kml &&
                    <ReactLeafletKml eventHandlers={{ click: handleMarkerClick }} kml={kml} />
                }
            </MapContainer>
        </div>
    );
}

export default Kml;